// ESM-Huelle um lib/scripts/pos/CLS_CPrinter.js (Phase 4, Welle 4a).
// Prototype-Stil bleibt vorerst.

// Strict-Mode-Fix (ESM): implizit zugewiesene Sloppy-Mode-Globals
// modulweit deklarieren (nur ZUGEWIESENE Namen - nur-gelesene wie
// process/lp behalten bewusst ihren vorbestehenden ReferenceError).
var buf, i, newJob;
function CPrinter() {
    this.fh = new CFileHandler();

    this.lines = new Array();
    this.lineCount = 0;

    this.fpout = null;
    this.inputStream = null;

    this.spPath = "spooler/";
    //this.spoolerPath = "file://" + this.spPath;
    this.spoolerPath = this.spPath;
     this.outputStream = this.spPath + "spooltemp";

    this.statusFile = new CFileHandler();
    this.statusFile.fileName = this.spoolerPath + "status";
    this.status = [0, 1, 1, 0, 0, 0, 0, 0];
    this.cashboxFileName = this.spoolerPath + "cashbox_status";

//    this.countFile = new CFileHandler();
    this.countFile = this.spoolerPath + "jobcount";
    this.encoding = null;

}

CPrinter.prototype.streamOutOpen = function() {
    try {

    } catch (e) {
        POS.message.show("Could not write to " + this.spPath + "spooltemp", "critical", "OK");
        return false;
    }
    return true;
}


CPrinter.prototype.toHexChunks = function(buf) {
        var command= buf.toString('hex');
        var chuncks = command.match(/.{1,2}/g);
        command = chuncks.join("").toUpperCase();
        return command;
}


CPrinter.prototype.printLogo = function() {

    var streamText = new Buffer([0x1B, 0x24, 0x00, 0x00, 0x1B, 0x5C, 0x88, 0x00, 0x1B, 0x53, 0x1C, 0x70, 0x01, 0x00]);
    try {
        //this.outputStream.write(streamText, streamText.length);
	return streamText;
        //fs.writeFileSyncHex(this.outputStream, this.toHexChunks(streamText), 0, streamText.length);
    } catch (e) {
        log.add(2, "Error", "outputStream.write() failed with logo", e);
    }
}

CPrinter.prototype.setCharSet = function() {
    /*var streamText = "%1B%24%00%00%1B%5C%88%00%1B%53%1C%70%01%00";
    streamText = unescape(streamText);*/
    var streamText = new Buffer([0x1B, 0x52, 0x02]); //german
    //streamText = streamTextBuff.toString();
    try {
        //this.outputStream.write(streamText, streamText.length);
		return streamText;
        //fs.writeFileSyncHex(this.outputStream, this.toHexChunks(streamText), 0, streamText.length);
    } catch (e) {
        log.add(2, "Error", "outputStream.write() failed with logo", e);
    }
}

CPrinter.prototype.print = function() {
    if (POS.EnvProperties.PRINTER == "NO")
        return true;

    /*privMan.enablePrivilege (privList);*/

   /* if (!this.streamOutOpen()) {
        log.add(2, "Error", "streamOutOpen() failed");
        return false;
    }*/
    // text war frueher ueber die (jetzt in layoutLine liegende) Elementschleife
    // in print() deklariert; der catch-Zweig unten weist ihn zu.
    var text;
    var bonbuffer = this.setCharSet();
    bonbuffer = Buffer.concat([bonbuffer, this.printLogo()]);

    //Send all Lines to printer
    //go through all lines
    for (var cline = 0; cline < this.lineCount; cline++) {
        var currentLine = this.lines[cline];

        if (currentLine.type == "LN") {
            var printElements = this.layoutLine(currentLine);

            // send printElements to printer
            //var streamText = "";
            var streamText = new Buffer([]);
            var currentPos = 0;

            // font set manual page 39
            var buf = new Buffer([0x1B, 0x74, 0x13]);
            streamText = Buffer.concat([streamText, buf]);
            //streamText += buf.toString();
            // font manual page 35
            buf = new Buffer([0x1B, 0x4D]);
            var font = (currentLine.font == "A" ? 0 : 1);
            var buf2 = new Buffer([font]);
            streamText = Buffer.concat([streamText, buf, buf2]);
            //streamText += buf.toString() + (currentLine.font == "A" ? "00" : "01");
            // magnification manual page 40
            var HeightMag = Math.floor(currentLine.magnification / 2); //bit 0-3
            var WidthMag = Math.floor(currentLine.magnification / 2 - 0.5) << 4; //bits 4-7
            var Mag = HeightMag + WidthMag;
            buf = new Buffer([0x1D, 0x21, Mag]);
            streamText = Buffer.concat([streamText, buf]);
            //streamText += buf.toString(); //" 0x1D0x21 " + String(WidthMag) + String(HeightMag);
            // Underline manual page 32
            font = (currentLine.underline ? 1 : 0);
            buf2 = new Buffer([font]);
            buf = new Buffer([0x1B, 0x2D, buf2]);
            streamText = Buffer.concat([streamText, buf]);
            //streamText += buf.toString(); //" 0x1B0x2D % " + (currentLine.underline ? " 01 " : " 00 ");

            for (var elms in printElements) {
                // bold manual page 34
                font = (currentLine.underline ? 1 : 0);
                buf2 = new Buffer([font]);
                buf = new Buffer([0x1B, 0x45, buf2]);
                streamText = Buffer.concat([streamText, buf]);
                //streamText += buf.toString(); //" 0x1B0x45 / " + (printElements[elms].bold ? " 01 " : " 00 ");

                //sdump (" stre ", currentPos, printElements[elms].start);

                for (; currentPos < printElements[elms].start; currentPos++)
                    streamText = Buffer.concat([streamText, new Buffer([32])]);
                //streamText += " ";

                // text
                //text = printElements[elms].text.replace(/%/g, "\x25");
                streamText = Buffer.concat([streamText, printElements[elms].text]);
                //streamText += text;

                //sdump (" strtx ", streamText);

                currentPos = printElements[elms].end + 1;
                //sdump (" cpos ", currentPos);
            }

            if (currentLine.elementCount > 0) {
                buf = new Buffer([0x0D, 0x0A]);
                streamText = Buffer.concat([streamText, buf]);
                //streamText += buf.toString(); //" 0x0D0x0A ";
            }
        } else if (currentLine.type == "BC") {
            buf = new Buffer([0x1B, 0x61, 0x01, 0x1D, 0x77, 0x02, 0x1D, 0x68, parseInt(currentLine.size, 16), 0x1D, 0x6B, currentLine.code]);
            /*streamText += " 0x1B0x610x01 ";
            streamText += " 0x1D0x770x02 ";

            streamText += " 0x1D0x68 % " + expandInteger(currentLine.size, 2);
            streamText += " 0x1D0x6B % " + expandInteger(convert2Hex(currentLine.code), 2);*/
            streamText = Buffer.concat([streamText, buf]);
            //streamText += buf.toString();
            if (currentLine.group == 2) {
                buf = new Buffer([currentLine.text.length]);
                streamText = Buffer.concat([streamText, buf]);
                //streamText += buf.toString(); //" % " + expandInteger(convert2Hex(currentLine.text.length), 2);
            }
            //streamText += currentLine.text;
            streamText = Buffer.concat([streamText, new Buffer(currentLine.text)]);
            if (currentLine.group == 1) {
                buf = new Buffer([0x00]);
                streamText = Buffer.concat([streamText, buf]);
                //streamText += buf.toString(); //" 0x00 ";
            }
            buf = new Buffer([0x1B, 0x61, 0x00]);
            streamText = Buffer.concat([streamText, buf]);
            //streamText += buf.toString(); //" 0x1B0x610x00 ";
        } else if (currentLine.type == "IM") { //
          buf = new Buffer([0x1B, 0x61, 0x01]);
          streamText = Buffer.concat([streamText, buf]);
            /*            streamText += " % 1B % 2A ";
            streamText += " % " + expandInteger(convert2Hex(currentLine.mode), 2);
            streamText += " % " + expandInteger(convert2Hex(currentLine.nL), 2);
            streamText += " % " + expandInteger(convert2Hex(currentLine.nH), 2);
            streamText += " % " + DBPicture;*/
            streamText = Buffer.concat([streamText, currentLine.buffer]);
            buf = new Buffer([0x1B, 0x4A, 10]);
            streamText = Buffer.concat([streamText, buf]);
            buf = new Buffer([0x1B, 0x61, 0x00]);
            streamText = Buffer.concat([streamText, buf]);
        }

        if (currentLine.feed > 0) {
            buf = new Buffer([0x1B, 0x4A, currentLine.feed * 10]);
            streamText = Buffer.concat([streamText, buf]);
            //streamText += buf.toString(); //" 0x1B0x4A % " + currentLine.feed + " 0 ";

        }

		bonbuffer = Buffer.concat([bonbuffer, streamText]);
	}
        try {
            //this.outputStream.write(streamText, streamText.length);
            //fs.writeFileSyncHex(this.outputStream, this.toHexChunks(bonbuffer), 0, streamText.length);
        } catch (e) {
            log.add(2, "Error", "outputStream.write()failed at position 1", e);
            this.streamText = streamText;
            text = POS.lang.getText("MESSAGES", "PRINTER_ERROR");
            POS.message.show(text, "warning", "OK", this, this.catchPrintingError);
            return;
        }
    

    return this.cutAndFeed(bonbuffer);
}

// Positioniert die Elemente einer Textzeile (Typ "LN") auf die Spalten des
// Bondruckers - aus print() herausgeloest (e-Beleg, Stufe 0), damit der
// elektronische Beleg exakt dieselbe Aufteilung bekommt wie der Papierbon.
// Quelltext wortwoertlich aus print() uebernommen; print() ruft ihn auf.
CPrinter.prototype.layoutLine = function(currentLine) {
        var printElements = new Array();
        var lineLength = currentLine.font == "A" ? 42 : 56;

        //Iterate through all elements
        for (var celement = 0; celement < currentLine.elementCount; celement++) {
            var currentElement = currentLine.elements[celement];

            if (currentElement.start < 0)
                currentElement.start = 0;
            if (currentElement.start >= lineLength)
                currentElement.start = lineLength - 1;
            if (currentElement.end < 0)
                currentElement.end = 0;
            if (currentElement.end >= lineLength)
                currentElement.end = lineLength - 1;
            if (currentElement.end < currentElement.start)
                currentElement.end = currentElement.start;

            var start,
                end;
            //var text = String(currentElement.text);
            var text = currentElement.text;
            if (text.length == 0)
                continue;

            //sdump ("tx", text);

            if (currentElement.align == 0) {
                start = currentElement.anchor;
                end = start + text.length - 1;
            } else if (currentElement.align == 1) {
                end = currentElement.anchor;
                start = end - text.length + 1;
            } else {
                start = currentElement.anchor - Math.floor(text.length / 2);
                if (start < 0)
                    start = 0;
                end = start + text.length;
            }

            //sdump ("ste", start, end);

            var startshift = 0;
            var endshift = 0;

            if (start < currentElement.start) {
                startshift = currentElement.start - start;
            }
            if (end > currentElement.end) {
                endshift = end - currentElement.end;
            }

            // Correct startshift
            if (startshift > 0) {
                //text = text.substring(startshift, text.length - startshift);
                text = text.slice(startshift, text.length - startshift);
                start += startshift;
            }

            // Correct endshift
            if (endshift > 0) {
                //text = text.substring(0, text.length - endshift);
                text = text.slice(0, text.length - endshift);
                end -= endshift;
            }

            //sdump ("sts", startshift, endshift);
            //sdump ("tx2", text);

            var element = new Array();
            element["start"] = start;
            element["end"] = end;
            element["text"] = text;
            element["bold"] = currentElement.bold;
            printElements.push(element);
        }
        return printElements;
}

CPrinter.prototype.getStatusFromFile = function() {
  //  var isWin = /^win/.test(process.platform);
   // if (!isWin) {
        //if (navigator.platform != " Win32 ") {
        this.statusFile.open(true, true);
        //this.statusFile.readOpen();
        var status = parseFloat(this.statusFile.readAll().replace(/\r/g, ""));

        if (status == "1") {
            return true;
        } else {
            return false;
        }
    //}
}

CPrinter.prototype.getStatus = function(mode) {

    var status = [0, 0, 1, 0, 0, 0, 0, 0];

    status = this.status;

    switch (mode) {
        case "printer":
            try {
                //var x = fs.accessSync(path[, mode]);
                //status = fs.readFileSync(this.cashboxFileName, 'utf8');
                if (status.length < 8) {
                    status = [0, 0, 1, 0, 0, 0, 0, 0];
                }
            } catch (e) {
                console.log(e.toString());
                status = [0, 0, 1, 0, 0, 0, 0, 0];
            }
            break;
            //text += buf.toString(); //" 0x01 ";
        case "paper":
            break;
    }

    return status;

    /*-----------------------------old-----------------------------------------*/

    if (POS.EnvProperties.USBPRINTER && POS.EnvProperties.USBPRINTER == "NO") {
        return true;
    }

    var isWin = /^win/.test(process.platform);
    if (!isWin) {


        var text = new Buffer([0x10, 0x04]); //buf.toString(); //" 0x100x04 ";

        switch (mode) {
            case "printer":
                buf = new Buffer([0x01]);
                text = Buffer.concat([text, buf]);
                break;
                //text += buf.toString(); //" 0x01 ";
            case "paper":
                buf = new Buffer([0x04]);
                text = Buffer.concat([text, buf]);
                //text += buf.toString(); //" 0x04 ";
        }

        //text = unescape(text);
        //var device = " / dev / usb / lp0 ";
        var device = POS.EnvProperties.PRINTERPORT;
        //var device = " / dev / lp0 ";

        try {
            //var res = VisoTech.print(device, text);
            //var lp = fs.aooendFileSync(device, 'w+');
            //var lp = fs.createWriteStream(device);
            fs.appendFileSyncHex(lp, this.toHexChunks(text), 0, text.length);
            var res = new Buffer([0x00]);
            var result = fs.readSync(lp, res, 0, res.length);
            //fs.closeSync(lp);

            res = res.readUInt8(0);
        } catch (e) {
            log.add(1, "Error", "Could not communicate with the printer(getStatus in mode '" + mode + "')", e);
            return false;
        }

        var bits = new Array();

        for (var i = 0; i < 8; i++) {
            bits[i] = res & (1 << i);
        }

        return bits;
    } else {
        var bits = new Array();

        for (var i = 0; i < 8; i++) {
            bits[i] = i == 2 ? 0 : 0;
        }

        return bits;
    }
}

function decodeTxt(s) {
    var s1 = unescape(s.substr(0, s.length - 1));
    var t = '';
    for (i = 0; i < s1.length; i++)
        t += String.fromCharCode(s1.charCodeAt(i) - s.substr(s.length - 1, 1));
    return t;
    //turn unescape(t);
}

CPrinter.prototype.openDrawer = function() {
    /*privMan.enablePrivilege (privList);*/

    //if (!this.streamOutOpen())
      //  return;
    //var buf = new Buffer([0x1B, 0x70, 0x00, 0xA0, 0xA0]);
    var text = new Buffer([0x1B, 0x70, 0x00, 0xA0, 0xA0]);
    //var text = buf.toString(); //" 0x1B0x700x000xA00xA0 ";
    //text = unescape(text);
    /*
    this.outputStream.write(text, text.length);
    this.outputStream.close();*/
    fs.writeFileSyncHex(this.outputStream, this.toHexChunks(text), 0, text.length);
    //fs.closeSync(this.outputStream);
    this.moveTempFile();
}

function CPrintingLineElement(text, anchor, align, bold, start, end) {
    text = String(text);

    //sdump(" TX ", text);,
    text = text.replace(/\|/g, '\I');
    text = text.replace(/&euro;/g, '\xD5');
    text = text.replace(/&uuml;/g, '\x81');
    text = text.replace(/&Uuml;/g, '\x9A');
    text = text.replace(/&auml;/g, '\x84');
    text = text.replace(/&Auml;/g, '\x8E');
    text = text.replace(/&ouml;/g, '\x94');
    text = text.replace(/&Ouml;/g, "\x99");
    text = text.replace(/&szlig;/g, '\xE1'); //0xE1

    text = text.replace(/\|/g, '\I');
    text = text.replace(/&euro/g, '\xD5');
    text = text.replace(/&uuml/g, '\x81');
    text = text.replace(/&Uuml/g, '\x9A');
    text = text.replace(/&auml/g, '\x84');
    text = text.replace(/&Auml/g, '\x8E');
    text = text.replace(/&ouml/g, '\x94');
    text = text.replace(/&Ouml/g, "\x99");
    text = text.replace(/&szlig/g, '\xE1'); //0xE1
    var buf = new Buffer(text, 'ascii');
    //text = buf.toString('ascii');

    //sdump(" TXE ", text);

    //text = unescape(text);

    this.text = buf;
    this.anchor = anchor;
    this.align = align;
    this.bold = bold;

    this.start = start;
    this.end = end;
}

function CPrintingLine(font, magnification, underline, feed) {
    this.type = "LN";
    this.elements = new Array();
    this.elementCount = 0;
    this.font = font;
    this.underline = underline;
    this.magnification = magnification;
    this.feed = feed;
}

function CPrintingLineBarcode(size, group, code, text, feed) {
    this.type = "BC";
    this.size = size;
    this.group = group;
    this.code = code;
    this.text = text;
    this.feed = feed;
}

function CPrintingLineImage(buffer) { //(mode, nL, nH, bits) {
    this.type = "IM";
    /*this.mode = mode;
    this.nL = nL;
    this.nH = nH;
    this.bits = bits;*/
    this.buffer = buffer;
}

CPrinter.prototype.addElement = function(text, anchor, align, bold, start, end) {
    var Line = this.lines[this.lineCount - 1];
    Line.addElement(text, anchor, align, bold, start, end);
}

CPrintingLine.prototype.addElement = function(text, anchor, align, bold, start, end) {
    this.elements[this.elementCount] = new CPrintingLineElement(text, anchor, align, bold, start, end);
    this.elementCount++;
}

CPrinter.prototype.reset = function() {
    this.lines = new Array();
    this.lineCount = 0;
}

CPrinter.prototype.addLine = function(font, magnification, underline, feed) {
    this.lines[this.lineCount] = new CPrintingLine(font, magnification, underline, feed);
    this.lineCount++;
}

CPrinter.prototype.addBarcodeLine = function(size, group, code, text, feed) {
    this.lines[this.lineCount] = new CPrintingLineBarcode(size, group, code, text, feed);
    this.lineCount++;
}

CPrinter.prototype.addImageLine = function(buffer) {
    this.lines[this.lineCount] = new CPrintingLineImage(buffer); //(mode, nL, nH, bits);
    this.lineCount++;
}

CPrinter.prototype.addDivisionLine = function() {
    this.addLine("B", 1, false, 0);
    var text = new Buffer([]);
    //var char = "0xC4";
    for (var i = 0; i < 56; i++) {
        //text += "-";
        text = Buffer.concat([text, new Buffer([95])]);

    }
    //text = unescape(text);
    this.addElement(text.toString(), 0, 0, false, 0, 55);
}

CPrinter.prototype.moveTempFile = function() {
    var jobCount = this.getJobCountFromFile();
    /*   var VisoTech = Components.classes[" @ visotech.at / VisoTech;
    1 "].
    createInstance(Components.interfaces.nsIVisoTech);*/
    /*    var isWin = /^win/.test(process.platform);
        if (!isWin)
            execute("sleep 4;mv " + this.spPath + "spooltemp " + this.spPath + "printjob" + jobCount);*/
    if (fs.existsSync(this.spPath + "spooltemp")) {
        fs.rename(this.spPath + "spooltemp",this.spPath + "printjob"+jobCount);
       // fs.unlinkSync(this.spPath + "spooltemp"); //remove
    }
}

CPrinter.prototype.cutAndFeed = function(text) {
    //var buf = new Buffer([0x1D, 0x56, 0x42, 0x80]);
    var text = Buffer.concat([text,new Buffer([0x1D, 0x56, 0x42, 0x80]) ]);;
    //streamText = unescape(streamText);

    try {
        /*this.outputStream.write(streamText, streamText.length);
        this.outputStream.close();*/
        fs.writeFileSyncHex(this.outputStream, this.toHexChunks(text), 0, text.length);
//fs.closeSync(this.outputStream);
        this.moveTempFile();
    } catch (e) {
        log.add(2, "Error", "outputStream.write()failed at position 2", e);
    }

    this.reset();
    return true;
}

CPrinter.prototype.catchPrintingError = function(me, result) {
    var streamText = me.streamText;
    me.streamText = "";

    try {
        //me.outputStream.write(streamText, streamText.length);
        var buf = new Buffer(streamText);
        fs.writeFileSyncHex(me.outputStream, this.toHexChunks(buf), 0, buf.length);
    } catch (e) {
        log.add(2, "Error", "outputStream.write()failed at position 3", e);
    }

    return me.cutAndFeed();
}

CPrinter.prototype.head = function() {
    return this.getDBText("head");
    //return this.header;
}

CPrinter.prototype.foot = function() {
    return this.getDBText("foot");
    //return this.footer;
}

CPrinter.prototype.getDBText = function(mode) {

    var PrinterClass = this;

    var DBText = null;
    /*privMan.enablePrivilege (privList);*/
    var def = $.Deferred();
    var defret = $.Deferred();

    switch (mode) {
        case "head":
            var sql = "SELECT headertext FROM BONLAY";
            $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
                DBText = rows[0].headertext;
                sql = "SELECT * FROM SHOPS where POS_ID=" + POS.POSId;
                var Name = "";
                var address = "Portugieserstr.1";
                var loc = "2544 Leobersdorf";
                var tel = "+43 2256 64060";
                $.when(POS.SQLiteCon.execute(sql)).then(function(rows2) {
                    if (rows2.length > 0) {
                        var OpenTime = rows2[0].OpeningTime;
                        Name = rows2[0].Name;
                        address = rows2[0].Address2;
                        loc = rows2[0].Address1;
                        tel = rows2[0].Telephone;
                    } else {
                        OpenTime = null;
                        Name = "";
                    }
                    if (OpenTime) {
                        OpenTime = OpenTime.replace("#", ",");
                    } else {
                        OpenTime = "Mo.-Fr. 8.00 - 18.00 Uhr";
                    }
                    if (!Name) {
                        Name = "";
                    }

                    DBText = DBText.replace("$OpeningTime$", OpenTime);
                    DBText = DBText.replace("$Name$", Name);
                    DBText = DBText.replace("$Adresse$", address);
                    DBText = DBText.replace("$PLZ$", loc);
                    DBText = DBText.replace("$Tel$", tel);
                    //r.free();
                    def.resolve();
                });
            });
            break;
        case "foot":
            var sql = "SELECT footertext FROM BONLAY";
            $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
                DBText = rows[0].footertext;
                //r.free();
                def.resolve();
            });
            break;
    }
    $.when(def).done(function() {
        var DBLines = DBText.split("#");
        for (var i = 0; i < DBLines.length; i++) {
            var DBLineParts = DBLines[i].split("§");
            if (DBLineParts[0] == "br") {
                PrinterClass.addLine("B", 1, false, 1);
                continue;
            }

            // default print values:
            var font = "B";
            var magnification = 1;
            var text = DBLineParts[DBLineParts.length - 1];
            var anchor = 27;
            var align = 2;
            var bold = false;
            var end = 55;

            for (var j = 0; j < DBLineParts.length - 1; j++) {
                switch (DBLineParts[j]) {
                    case "center":
                        align = 2;
                        break;
                    case "right":
                        align = 1;
                        break;
                    case "left":
                        align = 0;
                        break;
                    case "h1":
                        font = "A";
                        magnification = 2;
                        switch (align) {
                            case 2:
                                anchor = 21;
                                break;
                            case 1:
                                anchor = 41;
                                break;
                            case 0:
                                anchor = 0;
                                break;
                        }
                        end = 41;
                        break;
                    case "h2":
                        font = "B";
                        magnification = 1;
                        switch (align) {
                            case 2:
                                anchor = 27;
                                break;
                            case 1:
                                anchor = 55;
                                break;
                            case 0:
                                anchor = 0;
                                break;
                        }
                        end = 55;
                        break;
                    case "bold":
                        bold = true;
                        break;
                }
            }

            PrinterClass.addLine(font, magnification, false, 0);
            PrinterClass.addElement(text, anchor, align, bold, 0, end);

        }
        defret.resolve();
    });
    return defret.promise();
}

CPrinter.prototype.getJobCountFromFile = function() {
    try {
        //this.countFile.open(true, true);
        //this.countFile.readOpen();

        var currentJob = parseFloat(fs.readFileSync(this.countFile).replace(/\r/g, ""));
        if (!currentJob)
            currentJob = 1;
        if (currentJob >= 1000)
            newJob = 1;
        else
            newJob = currentJob + 1;

        //this.countFile.deleteFile();
        //this.countFile.open(true, true);
        fs.writeFileSync(this.countFile,expandInteger(newJob, 4));
    } catch (e) {
        log.add(2, "Error", "Could not work on file " + this.countFile.fileName, e);
        return "1";
    }
    return expandInteger(currentJob, 4);
}


export { CPrinter };
